export function isValidVrm(vrm, isCMSUser = false) {
    const regex = /(?<Current>^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(?<Prefix>^[A-Z][0-9]{1,3}\s?[A-Z]{3}$)|(?<Suffix>^[A-Z]{3}\s?[0-9]{1,3}[A-Z]$)|(?<DatelessLongNumberPrefix>^[0-9]{1,4}\s?[A-Z]{1,2}$)|(?<DatelessShortNumberPrefix>^[0-9]{1,3}\s?[A-Z]{1,3}$)|(?<DatelessLongNumberSuffix>^[A-Z]{1,2}\s?[0-9]{1,4}$)|(?<DatelessShortNumberSufix>^[A-Z]{1,3}\s?[0-9]{1,3}$)|(?<DatelessNorthernIreland>^[A-Z]{1,3}\s?[0-9]{1,4}$)|(?<DiplomaticPlate>^[0-9]{3}\s?[DX]{1}\s?[0-9]{3}$)/;
    const cleanedVrm = vrm.replace(/\s+/g, '').toUpperCase();
    let valid = regex.test(cleanedVrm);

    if(!valid && window.bugsnag && !isCMSUser) {
        window.bugsnag.notify(new Error("Vehicle API Lookup Failed"), (event) => {
            event.severity = "warning";
            event.addMetadata("details", { reason:  "Invalid VRM entered", vrm: vrm ?? "Unknown" });
        })
    }
    return valid;
}

export function missingFieldErrorText(vehicle, cmsUser = false) {
    const missingFields = [];
    if (!vehicle.make) missingFields.push('Make');
    if (!vehicle.model) missingFields.push('Model');
    if (!vehicle.year) missingFields.push('Year');

    const lastField = missingFields.pop();
    const fieldsString = missingFields.length
        ? missingFields.join(', ') + ' and ' + lastField
        : lastField;


    return cmsUser ? `${fieldsString} missing, enter manually.` :  `${fieldsString} not found, please enter manually below.`;
}

export function vehicleMotorhomeRegex(vehicle) {
    const regex = /MOTOR\s*HOME|CARAVAN/i

    return (
        vehicle?.door_plan_literal && regex.test(vehicle.door_plan_literal)
    )
}  

export function resetVehicleWithError(error, vehicle) {
 
    vehicle.make = {value: null}
    vehicle.model = {value: null}
    vehicle.year = {value: null}
    vehicle.result = null
    vehicle.class = {value: null}
    vehicle.parts_exclude = ""
    vehicle.hidden = false
    vehicle.manual = false
    vehicle.vrm.error = error
        
    return vehicle
}

export function suggestCorrectedVRM(vrm) {
    // Suggested VRM only for default VRM format (7 characters)
    const cleanedVrm = vrm.replace(/\s+/g, '').toUpperCase();
    let chars = cleanedVrm.split('');
    // check if charcters has changed, if so we can relookup vrm
    let hasChanged = false;

    // First two characters are letters → change 0 to O
    if (chars[0] === '0') {
        chars[0] = 'O';
        hasChanged = true;
    }
    if (chars[1] === '0') {
        chars[1] = 'O';
        hasChanged = true;
    }

    // Third and fourth are digits → change O to 0
    if (chars[2] === 'O') {
        chars[2] = '0';
        hasChanged = true;
    }
    if (chars[3] === 'O') {
        chars[3] = '0';
        hasChanged = true;
    }

    // Last three characters are letters → change 0 to O
    for (let i = chars.length - 3; i < chars.length; i++) {
        if (chars[i] === '0') {
            chars[i] = 'O';
            hasChanged = true;
        }
    }

    const suggestion = chars.join('');
    // validVrm is used as a sanity check for example LLLOPPP hasChanged but we need to see if it's valid before hitting lookup again
    const validVrm = isValidVrm(suggestion);
    return {
        suggestion: `${suggestion.slice(0, 4)} ${suggestion.slice(4)}`,
        hasChanged: hasChanged,
        validVrm: validVrm,
    };
}